<template>
    <b-modal
			:id="id"
			centered
			size="sm"
			hide-footer
			hide-header
		>
			<div v-if="queryRunning" class="text-center pt-2">
				<h2 > {{ title }} </h2>
				<small > Query is running and can take more than 1 minute to complete </small>
				<p class="text-center mt-2"> <strong class="font-weight-600"> Running Time: </strong> {{ timerValue }} </p>
			</div>
			<div v-else class="text-center pt-2">
				<h2 > {{ title }} </h2>
				<br>
				<p > Query failed, would you like to retry? </p>
				<br>
				<b-button 
				variant="danger" 
				size="sm"
				@click="onCancel"
				>
					Cancel
				</b-button>
				<b-button 
				variant="primary" 
				size="sm"
				@click="onRetry"
				>
					Retry
				</b-button>
			</div>
		</b-modal>
</template>

<script>
export default {
    name: 'RequestTimer',
    props: {
        id: {
            type: String,
            default: 'request-timer'
        },
        title: {
            type: String,
            default: 'Request Timer'
        },
        queryRunning: {
            type: Boolean,
            default: false
        },
        onCancel: {
            type: Function,
            default: () => {console.warn('onCancel not defined')}
        },
        onRetry: {
            type: Function,
            default: () => {console.warn('onRetry not defined')}
        }
    },
    data() {
        return {
            queryTimer: 0
        }
    },
    computed: {
		timerValue() {
			let minutes = Math.floor(this.queryTimer / 60);
			let seconds = this.queryTimer - minutes * 60;
			if (minutes < 1) {
				return `${seconds} seconds`;
			} else {
				return `${minutes} minutes ${seconds} seconds`;
			}
		},
	},
    methods: {
        startTimer() {
            this.queryTimer = 0;
            this.timer = setInterval(() => {
                this.queryTimer++;
            }, 1000);
        },
        stopTimer() {
            clearInterval(this.timer);
        }
    },
    watch: {
        queryRunning: function (newVal, oldVal) {
            if (newVal) {
                this.startTimer();
            } else {
                this.stopTimer();
            }
        }
    }
}
</script>

